import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';
import { PaymentAuthorizeError } from './authorize';

const requestSchema = z.object({
	encryptedJourneyId: z.string(),
	paymentId: z.string(),
});

const responseSchema = z.object({ isSuccess: z.boolean() });

const paymentCapture = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/Payment/capture',
		method: 'POST',
		requestSchema,
		responseSchema,
		errorCodes: ['ValidaitionError', 'InternalError', 'PaymentAuthorizationFailed'],
		retryConfig: {
			retries: 1000,
			retryDelay: (retryCount) => {
				const delay = 2 ** retryCount * 100;

				return delay > 3000 ? 3000 : delay;
			},
		},
	});

export default paymentCapture;

export type PaymentCaptureResponse = TypeOfAPIResponse<ReturnType<typeof paymentCapture>>;

export type PaymentCaptureError = TypeOfAPIError<ReturnType<typeof paymentCapture>>;

export type PaymentErrors = PaymentAuthorizeError & PaymentCaptureError;
